import { useState, useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Button } from './ui/button';
import { ArrowRight } from 'lucide-react';
import { useGateModal } from '../hooks/useGateModal';

const StickyMobileCTA = () => {
  const { openGate, isOpen } = useGateModal();
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const hero = document.querySelector('[data-testid="hero-section"]');
    if (!hero) return;

    const observer = new IntersectionObserver(
      ([entry]) => {
        // Show CTA when hero is no longer visible
        setVisible(!entry.isIntersecting);
      },
      { threshold: 0.1 }
    );

    observer.observe(hero);
    return () => observer.disconnect();
  }, []);

  // Hide when quiz modal is open
  if (isOpen) return null;

  return (
    <AnimatePresence>
      {visible && (
        <motion.div
          initial={{ y: 100, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          exit={{ y: 100, opacity: 0 }}
          transition={{ duration: 0.3 }}
          className="fixed bottom-0 left-0 right-0 z-40 lg:hidden"
        >
          <div className="bg-tc-bg/95 backdrop-blur-md border-t border-tc-border px-4 py-3 pb-[calc(0.75rem+env(safe-area-inset-bottom))]">
            <Button
              onClick={openGate}
              className="w-full bg-tc-primary hover:bg-tc-primary-hover text-white py-6 text-base font-bold tracking-wider rounded-full btn-glow"
              data-testid="sticky-cta-btn"
            >
              CARI TAHU GAYA TRADING ANDA
              <ArrowRight className="w-5 h-5 ml-2" />
            </Button>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};

export default StickyMobileCTA;
